// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'adieuBold', 'adieuBold Fallback', sans-serif"},"className":"__className_1dd30f"};